export enum UserActionSuccessTypeEnum {
  USER_ADDED,
  USER_REMOVED,
  USER_REMOTE_SHARE_RIGHTS_SETTING_UPDATED,
  USER_DESKTOP_WEBAPP_ACCESS_SETTING_UPDATED,
  USER_GROUP_SHARING_SETTING_UPDATED,
  USER_NAME_UPDATED,
  GROUP_IN_USER_UPDATED,
  USER_IS_ADMIN_SETTING_UPDATED,
  USER_BETA_TESTER_SETTING_UPDATED,
  USER_COUNTRY_UPDATED,
  USER_USER_STATUS_UPDATED,
  USER_TYPE_APP_ACCESS_UPDATED,
  USER_EMAIL_UPDATED,
  USER_PASSWORD_RESET_EMAIL_SENT
}
